export default function getSubPositionIndex({ targetWordToDisplay, originalWordToDisplay }) {
    const subPositionIndex = targetWordToDisplay.split("").map((letter, index) => {
        if (letter !== originalWordToDisplay[index]) return index
        return null
    }).find(diffIndex => diffIndex !== null)

    return subPositionIndex
}